export default __webpack_public_path__ + "8bef3fa37463eb95ec471760bb36ff85.png";